import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    className as _$cn,
} from 'intact';
import {getClassAndStyleForFixed} from './useFixedColumns';
import {get, noop} from 'intact-shared';
import {Button} from '../button';
import {Icon} from '../icon';
import {getTextByChildren} from '../utils';

var _$tmp0 = {
    'className': 'ion-ios-arrow-right',
    'size': 'small'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        props, rowIndex, columnIndex, offset,
        data, checkType, indent, grid,
        colspan, rowspan, onClickArrow, hasChildren,
    } = this.get();
    
    const blocks = props.$blocks; 
    let children = get(data, props.key);
    if (blocks) {
        const template = blocks.template || blocks.default;
        if (template) {
            children = template(noop, [data, rowIndex]);
        }
    }
    
    let {className, style} = getClassAndStyleForFixed(props, offset, checkType);
    if (columnIndex === 0 && indent) {
        style || (style = {});
        style.paddingLeft = `${indent}px`;
    }
    
    return _$ce(2, 'td', [
        (columnIndex === 0 && hasChildren) ?
            _$cc(Button, {
                'type': 'none',
                'icon': true,
                'circle': true,
                'size': 'mini',
                'className': 'k-table-arrow',
                'ev-click': onClickArrow,
                'children': (
                    _$cc(Icon, _$tmp0)
                )
            }) :
            undefined,
        children
    ], 0, _$cn(className), {
        'style': style,
        'title': getTextByChildren(children),
        'rowspan': rowspan,
        'colspan': colspan
    });
};